import { useEffect, useState } from 'react';
import { useLocation, matchPath } from 'react-router-dom';

import { pathKeyMap } from '../utils/routes';
import { APP_ROUTES } from '../assets/MenuItems';
import { FORBIDDEN_ERROR, SESSION_EXPIRED_ERROR } from '../assets/AppConstants';

import { useAppContext } from '../contexts/app';
import { useUserContext } from '../contexts/user';
import { useAnalyticsContext } from '../contexts/analytics';

export const usePath = () => {
  const location = useLocation();
  const { requestStatus } = useAppContext();
  const { userIsLogged, userSession } = useUserContext();
  const { hotJar: { recordCurrentPage } } = useAnalyticsContext();
  const [pathObject, setPathObject] = useState(null);

  useEffect(() => {
    const pathKeyList = pathKeyMap(APP_ROUTES);
    let keyPath = pathKeyList[location.pathname] || null;

    if (!keyPath) {
      Object.keys(pathKeyList).forEach((el) => {
        if (matchPath({ path: el }, location.pathname)) {
          keyPath = pathKeyList[el];
        }
      });
    }

    setPathObject(keyPath);
    if (userIsLogged() && ![FORBIDDEN_ERROR, SESSION_EXPIRED_ERROR].includes(requestStatus)) {
      recordCurrentPage(keyPath, userSession);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return {
    pathObject,
    location,
  };
};
